document.addEventListener('keyup', (e) => {
  if (!e.code || e.code.toUpperCase() !== 'ESCAPE') return;
  const openGradient = document.querySelector('[id^="InfoDrawer--"] .menu-gradient.open');
  if (!openGradient) return;
  openGradient.closest('[id^="InfoDrawer--"]').closeMenuDrawer(e);
});

function fixIOSVideo(video) {
  var isIOS = /iP(ad|hone|od)/.test(navigator.userAgent);
  if (!isIOS) return;

  var parent = video.parentElement;
  var rebuilt = document.createElement('video');
  for (var i = 0; i < video.attributes.length; i++) {
    rebuilt.setAttribute(video.attributes[i].name, video.attributes[i].value);
  }
  rebuilt.muted = true;
  rebuilt.playsInline = true;
  rebuilt.setAttribute('webkit-playsinline', '');
  video.querySelectorAll('source').forEach(function (src) {
    var s = document.createElement('source');
    if (src.src) s.src = src.src;
    if (src.type) s.type = src.type;
    rebuilt.appendChild(s);
  });
  parent.replaceChild(rebuilt, video);

  function attemptPlay() {
    if (!rebuilt.isConnected) return;
    var p = rebuilt.play();
    if (p && typeof p.then === 'function') p.catch(function () {});
  }

  attemptPlay();
  if (rebuilt.paused) {
    rebuilt.addEventListener('loadeddata', function onLoaded() {
      rebuilt.removeEventListener('loadeddata', onLoaded);
      attemptPlay();
    });
    rebuilt.addEventListener('canplay', function onCanPlay() {
      rebuilt.removeEventListener('canplay', onCanPlay);
      attemptPlay();
    });
    setTimeout(function () { if (rebuilt.paused) attemptPlay(); }, 150);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="InfoDrawer--"] deferred-media').forEach((deferredMedia) => {
    new MutationObserver(() => {
      const video = deferredMedia.querySelector('video:not([data-ios-fixed])');
      if (!video) return;
      video.dataset.iosFixed = 'true';
      fixIOSVideo(video);
    }).observe(deferredMedia, { childList: true });
  });

  const links = document.querySelectorAll('a[href*="#info-drawer-"]');

  links.forEach((link) => {
    const hash = new URL(link.href, window.location.origin).hash;

    if (!hash.startsWith('#info-drawer--')) return;

    const handle = hash.slice('#info-drawer--'.length);
    const drawerId = `InfoDrawer--${handle}`;
    const drawer = document.getElementById(drawerId);

    if (!drawer) return;

    // Overlay and structural wrapper links: intercept in-place so element
    // structure and card layout are preserved (content cards, banner cards, etc.)
    if (link.querySelector('img, picture, video, svg, .visually-hidden, h1, h2, h3, h4, h5, h6, div')) {
      link.dataset.infoDrawerInit = 'true';
      link.addEventListener('click', (e) => {
        e.preventDefault();
        drawer.setTrigger(link);
        drawer.openMenuDrawer(link);
      });
      return;
    }

    // Simple text CTA links: replace with menu-drawer-trigger > button
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = link.textContent;
    button.setAttribute('aria-controls', drawerId);
    button.setAttribute('aria-haspopup', 'dialog');

    if (link.className) {
      button.className = link.className + ' info-drawer-trigger';
    } else {
      button.className = 'info-drawer-trigger--link info-drawer-trigger';
    }

    button.addEventListener('click', (e) => {
      e.preventDefault();
      drawer.setTrigger(button);
      drawer.openMenuDrawer(button);
    });

    const trigger = document.createElement('menu-drawer-trigger');
    trigger.appendChild(button);

    link.replaceWith(trigger);
  });
});

// Fallback for links not processed at DOMContentLoaded (e.g. PLP content cards
// re-injected by AJAX filtering). Skips links already handled above.
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href*="#info-drawer-"]:not([data-info-drawer-init])');
  if (!link) return;

  const hash = new URL(link.href, window.location.origin).hash;
  if (!hash.startsWith('#info-drawer--')) return;

  const handle = hash.slice('#info-drawer--'.length);
  const drawer = document.getElementById(`InfoDrawer--${handle}`);
  if (!drawer) return;

  e.preventDefault();
  drawer.setTrigger(link);
  drawer.openMenuDrawer(link);
});
